"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataLinkSchema = void 0;
const DISABLE_COLUMNS_TO_SAVE = true;
const getDataLinkSchema = ({ isEditing, projectId, segmentId, langAliases, originalScriptFields, }) => {
    var _a;
    return {
        schemaType: "object",
        properties: [
            {
                title: "見出し行",
                stacked: true,
                propertyName: "headerRowNumber",
                tooltip: "アップロードされたファイルのうち、見出しにする行を指定します。たとえば、一番上 (1行目) を見出し行として扱う場合 1 を、3 行目を見出し行として扱う場合 3 を指定します。",
                tooltipVariant: "fixed",
                schema: {
                    schemaType: "number",
                    required: false,
                    uiType: "number",
                    minValue: 1,
                },
            },
            {
                title: "Script ID の書式",
                stacked: true,
                propertyName: "scriptIdFormat",
                tooltip: "Script ID の書式を {列名} を使って指定します (例: {id}_{row_no})。列名の他に、 {row_no} と {sheet_name} が使えます。",
                schema: {
                    schemaType: "text",
                    required: false,
                },
            },
            {
                title: "翻訳前データの列名",
                stacked: true,
                propertyName: "originalScriptField",
                tooltip: "翻訳前データの列名を指定します (例: text_ja)。",
                schema: {
                    schemaType: "selector",
                    required: false,
                    options: (_a = originalScriptFields === null || originalScriptFields === void 0 ? void 0 : originalScriptFields.map((field) => ({
                        value: field,
                        title: field,
                    }))) !== null && _a !== void 0 ? _a : [],
                },
            },
            {
                title: "翻訳済みデータの列書式",
                stacked: true,
                propertyName: "translatedScriptFieldFormat",
                tooltip: "翻訳済みデータの列名の書式を {locale} を使って指定します (例: text{locale})。",
                schema: {
                    schemaType: "text",
                    required: false,
                },
            },
            ...(DISABLE_COLUMNS_TO_SAVE
                ? []
                : [
                    {
                        title: "列の紐づけ",
                        stacked: true,
                        propertyName: "columnsToSave",
                        tooltip: "任意の列の値を手動で紐づけます",
                        tooltipVariant: "fixed",
                        schema: {
                            schemaType: "array",
                            defaultValue: "列名",
                            item: {
                                schemaType: "text",
                            },
                            readOnly: true,
                        },
                    },
                ]),
        ],
    };
};
exports.getDataLinkSchema = getDataLinkSchema;
